<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3V9C3 10.1046 3.89543 11 5 11H11" stroke="black" stroke-width="1.33"/>
    <circle cx="3" cy="3" r="2.335" fill="white" stroke="black" stroke-width="1.33"/>
    <circle cx="11" cy="11" r="2.335" fill="white" stroke="black" stroke-width="1.33"/>
  </svg>
</template>

<script>
  export default {
    name: "SubtasksIcon"
  }
</script>

<style scoped>

</style>
